import Vue from 'vue'

import VueI18n from "vue-i18n";
 
Vue.use(VueI18n); // 全局挂载
 
import Cookies from 'js-cookie'
// import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
// import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import enLocale from './lan/en'
import zhLocale from './lan/zh'
console.log(zhLocale,999)
 
const messages = {
  en: {
    ...enLocale,
    // ...elementEnLocale
  },
  zh: {
    ...zhLocale,
    // ...elementZhLocale
  }
}
export function getLanguage() {
  const chooseLanguage = Cookies.get('language')
  if (chooseLanguage) return chooseLanguage
  return 'en'
}
export const i18n = new VueI18n({
  locale: localStorage.getItem("locale") || "zh", 
  messages
});

